import type { HelpFile } from '../../types/help'
import { ServerUnavailableOverlayTestIds } from '../../../testids/ServerUnavailableOverlayTestIds'

export const serverUnavailableOverlayHelp: HelpFile = {
  docPage: '/docs/troubleshooting/server-unavailable',
  texts: {
    [ServerUnavailableOverlayTestIds.serverUnavailableOverlay]: 'Das Backend ist nicht erreichbar — die Anwendung steht erst wieder zur Verfügung, wenn die Verbindung wiederhergestellt ist.',
    [ServerUnavailableOverlayTestIds.serverUnavailableHeading]: null,
  },
}
